import { render, staticRenderFns } from "./CategoryCoverManager.vue?vue&type=template&id=43e426be&scoped=true&lang=pug"
import script from "./CategoryCoverManager.vue?vue&type=script&lang=js"
export * from "./CategoryCoverManager.vue?vue&type=script&lang=js"
import style0 from "./CategoryCoverManager.vue?vue&type=style&index=0&id=43e426be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e426be",
  null
  
)

export default component.exports